<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('vendors_tab_mgt_purchase_requests')" name="purchaseRequest">
            </el-tab-pane>
            <el-tab-pane :label="$t('vendors_tab_mgt_purchase_orders')" name="purchaseOrder">
            </el-tab-pane>
            <el-tab-pane :label="$t('vendors_tab_mgt_receive_inventory_reports')" name="receiveInventoryReports">
            </el-tab-pane>
            <el-tab-pane :label="$t('vendors_tab_mgt_inspection_reports')" name="inspectionReports">
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: 'SupplyChainTab',
    components: {

    },
    created(){

    },
    computed:{

    },
    data(){
      return{
        activeName: 'purchaseRequest'
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
